<svg
  id="ezP7oaYFRUN1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 400 400"
  shape-rendering="geometricPrecision"
  text-rendering="geometricPrecision"
  width="400"
  height="400"
>
  <defs>
    <linearGradient
      id="ezP7oaYFRUN80-fill"
      x1="139.5863"
      y1="319.348"
      x2="205.7623"
      y2="319.348"
      spreadMethod="pad"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(0 0)"
    >
      <stop id="ezP7oaYFRUN80-fill-0" offset="0%" stop-color="#fad0c6" />
      <stop id="ezP7oaYFRUN80-fill-1" offset="100%" stop-color="#edbcb8" />
    </linearGradient>
    <linearGradient
      id="ezP7oaYFRUN112-fill"
      x1="212.6992"
      y1="225.5923"
      x2="215.3355"
      y2="247.4734"
      spreadMethod="pad"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(0 0)"
    >
      <stop id="ezP7oaYFRUN112-fill-0" offset="70.41%" stop-color="#fad0c6" />
      <stop id="ezP7oaYFRUN112-fill-1" offset="100%" stop-color="#edbcb8" />
    </linearGradient>
    <linearGradient
      id="ezP7oaYFRUN114-fill"
      x1="209.0582"
      y1="247.3409"
      x2="212.2217"
      y2="270.0129"
      spreadMethod="pad"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(0 0)"
    >
      <stop id="ezP7oaYFRUN114-fill-0" offset="70.41%" stop-color="#fad0c6" />
      <stop id="ezP7oaYFRUN114-fill-1" offset="100%" stop-color="#edbcb8" />
    </linearGradient>
    <linearGradient
      id="ezP7oaYFRUN116-fill"
      x1="207.5249"
      y1="267.8955"
      x2="210.6885"
      y2="289.513"
      spreadMethod="pad"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(0 0)"
    >
      <stop id="ezP7oaYFRUN116-fill-0" offset="70.41%" stop-color="#fad0c6" />
      <stop id="ezP7oaYFRUN116-fill-1" offset="100%" stop-color="#edbcb8" />
    </linearGradient>
  </defs>
  <g id="ezP7oaYFRUN2_to" transform="translate(215,137.386008)">
    <g id="ezP7oaYFRUN2_tr" transform="rotate(0)">
      <g id="ezP7oaYFRUN2" transform="translate(-83.800003,-114.599998)" opacity="0">
        <path d="M87.3,114.6c0,1.9-1.6,3.5-3.5,3.5s-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5Z" fill="#86ccce" />
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN4_to" transform="translate(230.5,138.288785)">
    <g id="ezP7oaYFRUN4_tr" transform="rotate(0)">
      <g id="ezP7oaYFRUN4" transform="translate(-57.700001,-169.399994)" opacity="0">
        <path d="M61.2,169.4c0,1.9-1.6,3.5-3.5,3.5s-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5Z" fill="#86ccce" />
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN6_to" transform="translate(212.222778,138.321366)">
    <g id="ezP7oaYFRUN6_tr" transform="rotate(0)">
      <g id="ezP7oaYFRUN6" transform="translate(-81.020821,-80.100002)" opacity="0">
        <g>
          <path d="M74.2,67.4l5.6,2.1c-.4,1.2-3.8,11.4,9.1,17.9l-2.7,5.4C71.8,85.6,72.1,73,74.2,67.4Z" fill="#86ccce" />
        </g>
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN9_to" transform="translate(216.771857,140.485274)">
    <g id="ezP7oaYFRUN9_tr" transform="rotate(0)">
      <g id="ezP7oaYFRUN9" transform="translate(-61.146557,-96.567688)" opacity="0">
        <g>
          <rect
            width="3.5"
            height="13.7"
            rx="0"
            ry="0"
            transform="matrix(.931-.3651 0.3651 0.931 57.016414 90.829291)"
            fill="#ec5f99"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN12_to" transform="translate(213.022416,138.770214)">
    <g id="ezP7oaYFRUN12_tr" transform="rotate(0)">
      <g id="ezP7oaYFRUN12" transform="translate(-42.959457,-145.975014)" opacity="0">
        <g>
          <rect
            width="13.7"
            height="3.5"
            rx="0"
            ry="0"
            transform="matrix(.7542-.6566 0.6566 0.7542 36.644189 149.152913)"
            fill="#fece48"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN15_to" transform="translate(211.085377,141.12423)">
    <g id="ezP7oaYFRUN15_tr" transform="rotate(0)">
      <g id="ezP7oaYFRUN15" transform="translate(-156.529533,-77.199997)" opacity="0">
        <g>
          <path d="M154.8,85.2l-1.8-3c.6-.4,5.9-3.9,2.3-11.5l3.2-1.5c4,8.6-.6,14.2-3.7,16Z" fill="#fece48" />
        </g>
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN18_to" transform="translate(217.635919,131.521359)">
    <g id="ezP7oaYFRUN18_tr" transform="rotate(1800)">
      <g id="ezP7oaYFRUN18" transform="translate(-33,-42)" opacity="0">
        <path
          d="M37.2,42c0,2.3-1.9,4.2-4.2,4.2s-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2c2.4,0,4.2,1.9,4.2,4.2Z"
          fill="#fece48"
        />
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN20_to" transform="translate(214.988747,140.099981)">
    <g id="ezP7oaYFRUN20_tr" transform="rotate(2160)">
      <g id="ezP7oaYFRUN20" transform="translate(0.035652,-108.832832)" opacity="0">
        <g>
          <rect
            width="5.2"
            height="20.1"
            rx="0"
            ry="0"
            transform="matrix(.3491-.9371 0.9371 0.3491-10.361144 107.760854)"
            fill="#ec5f99"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN23_to" transform="translate(215.824664,130.471712)">
    <g id="ezP7oaYFRUN23_tr" transform="rotate(1800)">
      <g id="ezP7oaYFRUN23" transform="translate(-10.129535,-151.899994)" opacity="0">
        <g>
          <path d="M8.4,159.9l-1.8-3c.6-.4,5.9-3.9,2.3-11.5l3.2-1.5c4,8.6-.6,14.2-3.7,16Z" fill="#ec5f99" />
        </g>
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN26_to" transform="translate(211.077076,138.80973)">
    <g id="ezP7oaYFRUN26_tr" transform="rotate(0)">
      <g id="ezP7oaYFRUN26" transform="translate(-105.421234,-58.199997)" opacity="0">
        <g>
          <path d="M103.7,66.2l-1.8-3c.6-.4,5.9-3.9,2.3-11.5l3.2-1.5c4,8.6-.7,14.2-3.7,16Z" fill="#a47db7" />
        </g>
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN29_to" transform="translate(215.301386,134.96496)">
    <g id="ezP7oaYFRUN29_tr" transform="rotate(1800)">
      <g id="ezP7oaYFRUN29" transform="translate(-140.732246,-28.378805)" opacity="0">
        <g>
          <rect
            width="21"
            height="5.4"
            rx="0"
            ry="0"
            transform="matrix(.7543-.6566 0.6566 0.7543 131.039277 33.236491)"
            fill="#ec5f99"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN32_to" transform="translate(210.429394,138.720033)">
    <g id="ezP7oaYFRUN32_tr" transform="rotate(0)">
      <g id="ezP7oaYFRUN32" transform="translate(-90.900002,-40.799999)" opacity="0">
        <path
          d="M94.4,40.8c0,1.9-1.6,3.5-3.5,3.5s-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5c2,0,3.5,1.6,3.5,3.5Z"
          fill="#ec5f99"
        />
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN34_to" transform="translate(201.556881,157.182267)">
    <g id="ezP7oaYFRUN34_tr" transform="rotate(-1800)">
      <g id="ezP7oaYFRUN34" transform="translate(-29.131314,11.059706)" opacity="0">
        <g>
          <rect
            width="13.7"
            height="3.5"
            rx="0"
            ry="0"
            transform="matrix(.7543-.6566 0.6566 0.7543 22.81531-7.882019)"
            fill="#fece48"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN37_to" transform="translate(195.04613,84.4786)">
    <g id="ezP7oaYFRUN37_tr" transform="rotate(1800)">
      <g id="ezP7oaYFRUN37" transform="translate(-160.100006,-3.5)" opacity="0">
        <path d="M163.6,3.5c0,1.9-1.6,3.5-3.5,3.5s-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5Z" fill="#86ccce" />
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN39_to" transform="translate(211.004437,139.651132)">
    <g id="ezP7oaYFRUN39_tr" transform="rotate(0)">
      <g id="ezP7oaYFRUN39" transform="translate(-298.899994,-101.097775)" opacity="0">
        <path
          d="M302.4,101.1c0,1.9-1.6,3.5-3.5,3.5s-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5c1.9-.1,3.5,1.5,3.5,3.5Z"
          fill="#80bf74"
        />
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN41_to" transform="translate(209.005987,139.70081)">
    <g id="ezP7oaYFRUN41_tr" transform="rotate(0)">
      <g id="ezP7oaYFRUN41" transform="translate(-285.257523,-78.740002)" opacity="0">
        <g>
          <rect
            width="3.5"
            height="13.7"
            rx="0"
            ry="0"
            transform="matrix(.931-.365 0.365 0.931 281.128 73.0014)"
            fill="#fece48"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN44_to" transform="translate(204.670352,104.708749)">
    <g id="ezP7oaYFRUN44_tr" transform="rotate(1800)">
      <g id="ezP7oaYFRUN44" transform="translate(-294.853638,3.842683)" opacity="0">
        <g>
          <rect
            width="3.5"
            height="13.7"
            rx="0"
            ry="0"
            transform="matrix(.931-.3651 0.3651 0.931 290.723563-9.581568)"
            fill="#86ccce"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN47_to" transform="translate(221.311244,109.808822)">
    <g id="ezP7oaYFRUN47_tr" transform="rotate(1800)">
      <g id="ezP7oaYFRUN47" transform="translate(-262.5,-27.899998)" opacity="0">
        <path
          d="M266.7,27.9c0,2.3-1.9,4.2-4.2,4.2s-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2c2.4,0,4.2,1.9,4.2,4.2Z"
          fill="#ec5f99"
        />
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN49_to" transform="translate(219.820754,138.710415)">
    <g id="ezP7oaYFRUN49_tr" transform="rotate(1800)">
      <g id="ezP7oaYFRUN49" transform="translate(-392.100006,-98.599998)" opacity="0">
        <path d="M395.6,98.6c0,1.9-1.6,3.5-3.5,3.5s-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5Z" fill="#86ccce" />
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN51_to" transform="translate(215.667474,138.689772)">
    <g id="ezP7oaYFRUN51_tr" transform="rotate(1800)">
      <g id="ezP7oaYFRUN51" transform="translate(-366.014374,-104.989117)" opacity="0">
        <g>
          <rect
            width="5.2"
            height="20.1"
            rx="0"
            ry="0"
            transform="matrix(.3492-.9371 0.9371 0.3492 355.689171 103.915792)"
            fill="#80bf74"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN54_to" transform="translate(211.298341,140.697712)">
    <g id="ezP7oaYFRUN54_tr" transform="rotate(0)">
      <g id="ezP7oaYFRUN54" transform="translate(-326.899994,-94.099998)" opacity="0">
        <path d="M331.1,94.1c0,2.3-1.9,4.2-4.2,4.2s-4.2-1.9-4.2-4.2s1.9-4.2,4.2-4.2s4.2,1.9,4.2,4.2Z" fill="#86ccce" />
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN56_to" transform="translate(200.276288,140.196726)">
    <g id="ezP7oaYFRUN56_tr" transform="rotate(1800)">
      <g id="ezP7oaYFRUN56" transform="translate(-407.321533,-178.536766)" opacity="0">
        <g>
          <rect
            width="13.7"
            height="3.5"
            rx="0"
            ry="0"
            transform="matrix(.7543-.6566 0.6566 0.7543 401.005519 181.71494)"
            fill="#ec5f99"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN59_to" transform="translate(214.130471,140.485297)">
    <g id="ezP7oaYFRUN59_tr" transform="rotate(0)">
      <g id="ezP7oaYFRUN59" transform="translate(-353.698929,-174.399994)" opacity="0">
        <g>
          <path
            d="M346.9,161.7l5.6,2.1c-.4,1.2-3.8,11.4,9.1,17.9l-2.7,5.4c-14.4-7.3-14.2-19.8-12-25.4Z"
            fill="#ec5f99"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN62_to" transform="translate(203.984946,138.150001)">
    <g id="ezP7oaYFRUN62_tr" transform="rotate(0)">
      <g id="ezP7oaYFRUN62" transform="translate(-59.375599,-198.192513)" opacity="0">
        <g>
          <rect
            width="5.2"
            height="20.1"
            rx="0"
            ry="0"
            transform="matrix(.349-.9371 0.9371 0.349 49.050478 197.121523)"
            fill="#a47db7"
          />
        </g>
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN65_to" transform="translate(219.820748,138.797151)">
    <g id="ezP7oaYFRUN65_tr" transform="rotate(1800)">
      <g id="ezP7oaYFRUN65" transform="translate(-374.399994,-154.5)" opacity="0">
        <path d="M381.6,154.5c0,4-3.2,7.2-7.2,7.2s-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2s7.2,3.3,7.2,7.2Z" fill="#d2eaec" />
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN67_to" transform="translate(215.979619,138.797151)">
    <g id="ezP7oaYFRUN67_tr" transform="rotate(1800)">
      <g id="ezP7oaYFRUN67" transform="translate(-240.099991,-18.599146)" opacity="0">
        <path
          d="M249.7,18.6c0,5.3-4.3,9.6-9.6,9.6s-9.6-4.3-9.6-9.6s4.3-9.6,9.6-9.6c5.3-.1,9.6,4.2,9.6,9.6Z"
          fill="#d2eaec"
        />
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN69_to" transform="translate(212.181816,137.032907)">
    <g id="ezP7oaYFRUN69_tr" transform="rotate(1800)">
      <g id="ezP7oaYFRUN69" transform="translate(-95.400002,-25.799999)" opacity="0">
        <path d="M102.6,25.8c0,4-3.2,7.2-7.2,7.2s-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2s7.2,3.2,7.2,7.2Z" fill="#d2eaec" />
      </g>
    </g>
  </g>
  <g id="ezP7oaYFRUN71_to" transform="translate(177.631822,485.31354)">
    <g id="ezP7oaYFRUN71_tr" transform="rotate(73.936965)">
      <g transform="translate(-173.329767,-399.999984)">
        <g>
          <g>
            <g>
              <g>
                <g>
                  <image
                    width="327"
                    height="810"
                    xlink:href="F9E3AADD6AE535FB.png"
                    preserveAspectRatio="xMidYMid meet"
                    transform="matrix(.24 0 0 0.24 137.52 249.12)"
                    opacity="0.05"
                  />
                  <g>
                    <g>
                      <path
                        d="M204.3,298.4l1.4,75c0,0-6.2,9.4-29,9.9-22.8.6-37.2-9.9-37.2-9.9l1.3-85.9c.3-17.3,13.5-31.7,30.3-32.2.5,0,1,0,1.6,0c32.7,0,31.6,30.8,31.6,43.1Z"
                        fill="url(#ezP7oaYFRUN80-fill)"
                      />
                      <path
                        d="M205.8,346.8v90.6c0,0-3.7-.6-26.5,0-22.8.5-39.7-5.4-39.7-5.4v-85.1c0,0,14.4,10.5,37.2,9.9c22.8-.7,29-10,29-10Z"
                        fill="#00a19a"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g>
                <circle r="42.4" transform="translate(181.9 277.2)" fill="#fad0c6" />
              </g>
            </g>
            <g id="ezP7oaYFRUN90_tr" transform="translate(199.846825,246.405387) rotate(15)">
              <g transform="translate(-199.846825,-246.405387)">
                <g>
                  <g>
                    <path
                      d="M207.7,129.6l-38,4.4c.8,6.7-4,12.8-10.7,13.6l11.1,96.2c6.7-.8,12.8,4,13.6,10.7l38-4.4c-.8-6.7,4-12.8,10.7-13.6l-11.1-96.2c-6.8.8-12.9-4-13.6-10.7Z"
                      fill="#fbc744"
                    />
                    <path
                      d="M180.9,157.8l4.7,40.7c.2,2.1-1.3,4-3.4,4.2v0c-2.1.2-4-1.3-4.2-3.4l-4.7-40.7c-.2-2.1,1.3-4,3.4-4.2v0c2-.2,4,1.3,4.2,3.4Z"
                      fill="#e5b33e"
                    />
                    <path
                      d="M195.3,156.1l4.7,40.7c.2,2.1-1.3,4-3.4,4.2v0c-2.1.2-4-1.3-4.2-3.4l-4.7-40.7c-.2-2.1,1.3-4,3.4-4.2v0c2.1-.2,4,1.3,4.2,3.4Z"
                      fill="#e5b33e"
                    />
                    <path
                      d="M209.7,154.5l4.7,40.7c.2,2.1-1.3,4-3.4,4.2v0c-2.1.2-4-1.3-4.2-3.4l-4.7-40.7c-.2-2.1,1.3-4,3.4-4.2v0c2.1-.2,4,1.3,4.2,3.4Z"
                      fill="#e5b33e"
                    />
                    <path
                      d="M211.7,230.2v0c.6,5.6-3.3,10.6-8.9,11.2l-2,.2c-5.6.6-10.6-3.3-11.2-8.9v0c-.6-5.6,3.3-10.6,8.9-11.2l2-.2c5.5-.6,10.5,3.4,11.2,8.9Z"
                      fill="#e5b33e"
                    />
                    <line
                      x1="166.7"
                      y1="214.8"
                      x2="229"
                      y2="207.6"
                      fill="none"
                      stroke="#e5b33e"
                      stroke-width="3.5234"
                      stroke-miterlimit="10"
                      stroke-dasharray="7.0468"
                    />
                    <path
                      d="M207.7,129.6l-38,4.4c.8,6.7-4,12.8-10.7,13.6l11.1,96.2c6.7-.8,12.8,4,13.6,10.7l38-4.4c-.8-6.7,4-12.8,10.7-13.6l-11.1-96.2c-6.8.8-12.9-4-13.6-10.7Z"
                      opacity="0.1"
                    />
                  </g>
                </g>
              </g>
            </g>
            <path
              d="M141.1,265.6l18.5-64.7c1.1-4.2,4.3-7.6,8.4-8.7c3.1-.8,6.8-.4,10.1,3.5c5.7,6.6,6.6,14.4,6.7,18.1c0,1.3-.2,2.5-.5,3.7l-3.2,11c-1.1,3.8-3.3,7.2-6.3,9.8l-3.7,3.2"
              fill="#fad0c6"
            />
          </g>
          <g>
            <g transform="matrix(1.090239 0 0 1.090239-23.575537-22.0894)">
              <g id="ezP7oaYFRUN103_tr" transform="translate(196.381066,237.736812) rotate(15)">
                <g transform="translate(-196.381066,-237.736812)">
                  <g>
                    <path
                      d="M255.9,145.1L219,131.4c-2.4,6.5-9.6,9.8-16.1,7.4L168.2,232c6.5,2.4,9.8,9.6,7.4,16.1l36.8,13.7c2.4-6.5,9.6-9.8,16.1-7.4l34.7-93.2c-6.5-2.4-9.8-9.6-7.3-16.1Z"
                      fill="#fbc744"
                    />
                    <path
                      d="M218.2,158.4l-14.7,39.5c-.8,2-3,3.1-5.1,2.3v0c-2-.8-3.1-3-2.3-5.1l14.7-39.5c.8-2,3-3.1,5.1-2.3v0c2,.8,3.1,3.1,2.3,5.1Z"
                      fill="#e5b33e"
                    />
                    <path
                      d="M232.2,163.6l-14.7,39.5c-.8,2-3,3.1-5.1,2.3v0c-2-.8-3.1-3-2.3-5.1l14.7-39.5c.8-2,3-3.1,5.1-2.3v0c2,.8,3.1,3.1,2.3,5.1Z"
                      fill="#e5b33e"
                    />
                    <path
                      d="M246.2,168.8l-14.7,39.5c-.8,2-3,3.1-5.1,2.3v0c-2-.8-3.1-3-2.3-5.1L238.8,166c.8-2,3-3.1,5.1-2.3v0c2,.8,3,3.1,2.3,5.1Z"
                      fill="#e5b33e"
                    />
                    <path
                      d="M212.6,239v0c-2,5.4-8,8.1-13.4,6.1l-1.9-.7c-5.4-2-8.1-8-6.1-13.4v0c2-5.4,8-8.1,13.4-6.1l1.9.7c5.4,2,8.1,8,6.1,13.4Z"
                      fill="#e5b33e"
                    />
                    <line
                      x1="178.6"
                      y1="204"
                      x2="239"
                      y2="226.4"
                      fill="none"
                      stroke="#e5b33e"
                      stroke-width="3.6168"
                      stroke-miterlimit="10"
                      stroke-dasharray="7.2337"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g>
              <path
                d="M234.8,245.9L196,250.4c-6.4.7-12.2-3.9-12.9-10.2v0c-.7-6.4,3.9-12.2,10.2-12.9l38.8-4.5c6.4-.7,12.2,3.9,12.9,10.2v0c.8,6.4-3.8,12.2-10.2,12.9Z"
                fill="url(#ezP7oaYFRUN112-fill)"
              />
            </g>
            <g>
              <path
                d="M231.4,267.8l-38.8,4.5c-6.4.7-12.2-3.9-12.9-10.2v0c-.7-6.4,3.9-12.2,10.2-12.9l38.8-4.5c6.4-.7,12.2,3.9,12.9,10.2v0c.7,6.4-3.9,12.2-10.2,12.9Z"
                fill="url(#ezP7oaYFRUN114-fill)"
              />
            </g>
            <g>
              <path
                d="M229.9,288.4l-38.8,4.5c-6.4.7-12.2-3.9-12.9-10.2v0c-.7-6.4,3.9-12.2,10.2-12.9l38.8-4.5c6.4-.7,12.2,3.9,12.9,10.2v0c.8,6.4-3.8,12.2-10.2,12.9Z"
                fill="url(#ezP7oaYFRUN116-fill)"
              />
            </g>
            <g>
              <path
                d="M225.1,309.1l-38.8,4.5c-6.4.7-12.2-3.9-12.9-10.2v0c-.7-6.4,3.9-12.2,10.2-12.9l38.8-4.5c6.4-.7,12.2,3.9,12.9,10.2v0c.7,6.3-3.9,12.2-10.2,12.9Z"
                fill="#fad0c6"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>
